import { forwardRef } from "react";

import CommentIcon from "./comment-widget-icon.svg";
import { Container, CountMessage, NoPostMessage, StyledButton } from "./styles";

type Props = React.DetailsHTMLAttributes<HTMLDivElement> & {
  className?: string;
  commentCount: number;
  onClick?: () => void;
};

export const ArticleCommentsWidget = forwardRef<HTMLDivElement, Props>(
  ({ className, commentCount, onClick }, reference) => (
    <Container className={className} ref={reference}>
      {commentCount > 0 ? (
        <CountMessage>{commentCount}</CountMessage>
      ) : (
        <NoPostMessage>Post</NoPostMessage>
      )}
      <StyledButton onClick={onClick}>
        <CommentIcon />
      </StyledButton>
    </Container>
  ),
);

ArticleCommentsWidget.displayName = "ArticleCommentsWidget";
